import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import {
  Popover,
  Transition,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { Storage } from "@utils";
import { deleteUserData } from "@redux/user/slice";
import {
  updateGolfclixUserDetail,
  updateGolfclixUserToken,
} from "@redux/authentication/slice";
import defaultUser from "@assets/images/defaultUser.png";

export default function DropDown(props) {
  const dispatch = useDispatch();
  const [dropIcon, setDropIcon] = useState(false);
  const { t } = useTranslation("common");

  const handleLogout = async (e) => {
    await Storage.remove(Storage.USER_DETAIL);
    await Storage.remove("W2G_UserToken");
    dispatch(deleteUserData(null));
    dispatch(updateGolfclixUserDetail(null));
    dispatch(updateGolfclixUserToken(null));
  };

  const ArrowUp = () => {
    return (
      <ChevronUpIcon className="h-6 w-6 text-btnTextColor" aria-hidden="true" />
    );
  };

  const ArrowDown = () => {
    return (
      <ChevronDownIcon
        className="h-6 w-6 text-btnTextColor"
        aria-hidden="true"
      />
    );
  };

  return (
    <Popover className="relative">
      <PopoverButton className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900 focus:outline-none">
        <div className="w-[40px] h-[40px] rounded-full ring-2 ring-primary">
          <img
            alt=""
            src={props.image || defaultUser}
            style={{
              width: 40,
              height: 40,
              color: "white",
              borderRadius: "50%",
            }}
          />
        </div>
        <span
          className={`text-[17px] capitalize font-sans font-medium text-btnTextColor ${props.titleStyle} ml-2`}
        >
          {t(`${props.title}`)}
        </span>
        {dropIcon === false ? <ArrowDown /> : <ArrowUp />}
      </PopoverButton>
      <Transition
        beforeLeave={() => setDropIcon(false)}
        beforeEnter={() => setDropIcon(true)}
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel className="absolute left-1/2 z-10 mt-2 flex w-screen max-w-min -translate-x-1/2 px-4">
          <div className="w-36  shrink rounded-xl bg-btnTextColor p-3 text-sm font-semibold leading-6 text-gray-900 ring-1 ring-gray-900/5 shadow-[0px_4px_5px_0px_rgba(229,226,255,0.80)]">
            {props.options.map((item, index) => (
              <div key={index}>
                <NavLink
                  key={item.value}
                  to={item.value}
                  className="block p-2 hover:text-primary text-[18px] font-sans font-medium"
                  onClick={
                    item.value === "/login" && item.index === 2
                      ? handleLogout
                      : null
                  }
                >
                  {item.title}
                </NavLink>
                {props.options.length - 1 === index ? (
                  <></>
                ) : (
                  <div className="w-full h-[1px] bg-[#DDDDDD]"></div>
                )}
              </div>
            ))}
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}
